<template>
  <div
    class="main scroll"
    @click="cancelContent"
    ref="scroll"
  >
    <div class="scroll-wrapper">
      <div class="head-title">
        <div class="left">
          <div @click="$router.back()" class="name">学生相册</div>
          <div class="icon">></div>
          <div class="main blue">
            {{ studentName }}
          </div>
        </div>
        <div class="right">
          <div class="num">已建立学生相册<span class="blue">{{albumList.length}}</span></div>
          <div class="msg">
            <div class="txt blue">相册信息</div>
            <a-icon style="{color:#898989}" type="caret-down" />
          </div>
        </div>
      </div>
      <div class="content">
        <div class="frame-list">
          <!-- <img
            @click="createModal = true"
            class="addframe"
            :src="require('@/assets/upload-01.png')"
            alt=""
          /> -->
          <div
            @click="toAlbum(index)"
            v-for="(item, index) in albumList"
            :key="index"
            class="cell"
            :style="{
              backgroundImage: item.select
                ? 'url(' + backimg2 + ')'
                : 'url(' + backimg1 + ')',
            }"
          >
            <div class="msg">
              <div class="top">
                <div class="name">{{ item.name }}</div>
                <!-- <img
                  class="edit"
                  :src="require('../assets/icon-16.png')"
                  alt=""
                /> -->
              </div>
              <div class="foot">
                <div class="num">照片数量：{{ item.count }}</div>
                <div class="order">{{ index | filterIndex }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="showRight"
        class="rightContent"
        :style="rightStyle"
      >
        <div @click="createModal = true" class="cell">添加相册</div>
        <div v-show="currentAlbum" @click="toclassalbum" class="cell">管理相册</div>
        <div @click="editModal = true" v-show="currentAlbum" class="cell">
          修改册名
        </div>
        <div @click="handleSelectAll" class="cell">选择全部</div>
        <div @click="delModal = true" class="cell">删除</div>
      </div>
      <a-modal :visible="createModal" centered :closable="false" footer="">
        <div class="modal3">
          <img :src="require('../assets/logo.png')" alt="" />
          <div class="msg">
            <div class="title">建立相册</div>
            <a-input
              v-model="albumName"
              placeholder="建立多个相册以一个空格隔开"
            />
            <div class="btns">
              <a-button @click="createModal = false">取消</a-button>
              <a-button @click="handleCreateAlbum" type="primary">
                确认
              </a-button>
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal :visible="editModal" centered :closable="false" footer="">
        <div class="modal3">
          <img :src="require('../assets/logo.png')" alt="" />
          <div class="msg">
            <div class="title">修改相册名称</div>
            <a-input
              v-if="currentAlbum"
              v-model="currentAlbum.name"
              :placeholder="currentAlbum ? currentAlbum.name : ''"
            />
            <div class="btns">
              <a-button @click="editModal = false">取消</a-button>
              <a-button @click="handleEditAlbum" type="primary">
                确认
              </a-button>
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal :visible="delModal" centered :closable="false" footer="">
        <div class="modal3 red">
          <img :src="require('../assets/log2.png')" alt="" />
          <div class="msg">
            <div class="title">删除此相册所有照片，不可恢复。是否继续？</div>
            <div class="btns">
              <a-button @click="delModal = false">取消</a-button>
              <a-button @click="handleDelAlbum" type="danger">
                确认
              </a-button>
            </div>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import BetterScroll from "better-scroll";
import _ from "lodash";
export default {
  data() {
    return {
      albumList: [],
      currentAlbum: null,
      currentIndex: -1,
      rightContentLeft: 0,
      rightContentTop: 0,
      showRight: false,
      albumName: "",
      createModal: false,
      editModal: false,
      delModal: false,
      backimg1: require("../assets/doc.png"),
      backimg2: require("../assets/doc-01.png"),
      studentList: [],
      studentName:'',
      id:'',
      rightStyle:{
        left:0,
        top:0
      }
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.scroll = new BetterScroll(this.$refs.scroll, {
    //     scrollY: true,
    //     scrollbar: true,
    //     mouseWheel: {
    //       speed: 20,
    //       invert: false,
    //       easeTime: 300,
    //     },
    //   });
    // });
  },
  computed: {
    ...mapState(["headers", "userInfo"]),
  },
  created() {
    this.id = this.$route.params.id 
    this.studentName = this.$route.query.name
    if (this.userInfo) {
      this.getAlbum();
      this.getStudent();
    }
  },
  filters: {
    filterIndex(index) {
      if (index < 9) {
        return "0" + (index + 1);
      } else {
        return index + 1;
      }
    },
  },
  watch: {
    userInfo(val) {
      if (val) {
        this.getAlbum();
        this.getStudent();
      }
    },
  },
  methods: {
    toclassalbum() {
      this.$router.push({path:`/classAlbum/${this.currentAlbum.id}`,query:{name:this.currentAlbum.name}})
    },
    toAlbum(index) {
      this.$router.push({path:`/studentAlbum/${this.albumList[index].id}/${this.id}`,query:{name:this.studentName}})
    },
    // getStudent() {
    //   this.$axios({
    //     method: "POST",
    //     url: this.$api.domain + this.$api.getClassStudent,
    //     headers: { Authorization: this.$store.state.headers },
    //     data: { class_id: this.userInfo.class_id },
    //   })
    //     .then((res) => {
    //       if (res.data.status == 200) {
    //         this.studentList = res.data.data.list;
    //       }
    //     })
    //     .catch(() => {
    //       this.$message.error("网络或服务器未知错误");
    //     });
    // },
    getStudent() {
      this.$axios({
        method:'POST',
        url:this.$api.domain + this.$api.studentList,
        headers:{Authorization:this.$store.state.headers}
      }).then((res)=>{
        this.studentList = res.data.data.rows
      }).catch((res)=>{
        this.$message.error(res.data.msg)
      })
    },
    selectAlbum($event, index) {
      if ($event.shiftKey) {
        this.albumList = this.albumList.map((arr, arrIndex) => {
          arr.select = false;
          if (this.currentIndex >= index) {
            if (arrIndex >= index && arrIndex <= this.currentIndex) {
              arr.select = true;
            }
          } else {
            if (arrIndex <= index && arrIndex >= this.currentIndex) {
              arr.select = true;
            }
          }
          return arr;
        });
        this.currentIndex = index;
        return false;
      }
      if ($event.ctrlKey) {
        this.albumList[index].select = !this.albumList[index].select;
        this.$forceUpdate();
        this.currentIndex = index;
        return false;
      }
      if (!$event.shiftKey && !$event.ctrlKey) {
        this.albumList = this.albumList.map((arr, index2) => {
          arr.select = false;
          if (index2 == index) {
            arr.select = true;
          }
          return arr;
        });
        this.currentIndex = index;
      }
    },
    editAlbum(index) {
      this.currentAlbum = _.cloneDeep(this.albumList[index]);
      this.editModal = true;
    },
    handleSelectAll() {
      this.albumList = this.albumList.map((arr) => {
        arr.select = true;
        return arr;
      });
    },
    handleEditAlbum() {
      if (!this.currentAlbum) {
        this.$message.error("未填写任何姓名");
      } else {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.editAlbum,
          headers: { Authorization: this.$store.state.headers },
          data: { id: this.currentAlbum.id, name: this.currentAlbum.name },
        })
          .then((res) => {
            this.studentName = "";
            this.$message.info(res.data.msg);
            if (res.data.status == 200) {
              this.editModal = false;
              this.getAlbum();
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
      }
    },
    handleDelAlbum() {
      var ids = [];
      this.albumList.forEach((arr) => {
        if (arr.select) {
          ids.push(arr.id);
        }
      });
      if (ids.length > 0) {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.delStudent,
          headers: { Authorization: this.$store.state.headers },
          data: { ids: ids.join(",") },
        })
          .then((res) => {
            this.$message.info(res.data.msg);
            if (res.data.status == 200) {
              this.delModal = false;
              this.getStudent();
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
      } else {
        this.$message.error("未选择任何相册");
      }
    },
    contentRight(e) {
      var clientWidth = document.body.clientWidth;
      var clientHeight = document.body.clientHeight;
      this.rightContentLeft =
        clientWidth - e.pageX < 120 ? e.pageX - 120 : e.pageX;
      if (clientHeight - e.pageY < 130) {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
          transform: "translateY(-100%)",
        };
      } else {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
        };
      }
      this.showRight = true;
      this.currentAlbum = null
      this.albumList = this.albumList.map((arr) => {
        arr.select = false;
        return arr;
      });
      console.log(e);
    },
    cancelContent() {
      this.showRight = false;
    },
    albumRight(e, index) {
      e.stopPropagation();
      var clientWidth = document.body.clientWidth;
      var clientHeight = document.body.clientHeight;
      this.rightContentLeft =
        clientWidth - e.pageX < 120 ? e.pageX - 120 : e.pageX;
      if (clientHeight - e.pageY < 130) {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
          transform: "translateY(-100%)",
        };
      } else {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
        };
      }
      this.showRight = true;
      if (!this.albumList[index].select) {
        this.albumList = this.albumList.map((arr) => {
          arr.select = false;
          return arr;
        });
        this.albumList[index].select = true;
      }
      this.currentAlbum = _.cloneDeep(this.albumList[index]);
      this.currentIndex = index;
    },
    handleCreateAlbum() {
      if (!this.albumName) {
        this.$message.error("未填写任何名称");
      } else {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.createAlbum,
          headers: { Authorization: this.$store.state.headers },
          data: { name: this.albumName },
        })
          .then((res) => {
            this.albumName = "";
            this.$message.info(res.data.msg);
            if (res.data.status == 200) {
              this.createModal = false;
              this.getAlbum();
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
      }
    },
    getAlbum() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.studentAlbum,
        headers: { Authorization: this.$store.state.headers },
        data: {
          student_id: this.id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            this.albumList = res.data.data.map((arr) => {
              arr.select = false;
              return arr;
            });
          } else {
            this.$message.error("暂无内容");
          }
          // this.$nextTick(() => {
          //   this.scroll = new BetterScroll(this.$refs.scroll, {
          //     scrollY: true,
          //     scrollbar: true,
          //     mouseWheel: {
          //       speed: 20,
          //       invert: false,
          //       easeTime: 300,
          //     },
          //   });
          // });
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("服务器或网络错误");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.student-list{
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  flex-wrap: wrap;
  .cell{
    cursor: pointer;
    margin-bottom: 30px;
  }
  .tx{
    width: 60px;
    height: 60px;
    border-radius: 60px;
    margin-right: 30px;
  }
  .name{
    width: 60px;
    text-align: center;
    color: #888;
    margin-top: 10px;
    font-size: 14px;
  }
}
.scroll {
  position: absolute;
  left: -20px;
  right: -20px;
  padding-left: 20px;
  top: 0;
  bottom: 0;
  overflow: hidden;
  box-sizing: border-box;
  .scroll-wrapper {
    height: 100%;
    overflow-y: scroll;
    padding-right: 20px;
    box-sizing: border-box;
  }
}
.head-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  .left {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .main {
      font-size: 16px;
    }
  }
  .right {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    .msg {
      display: flex;
      flex-direction: row;
      align-items: center;
      .txt {
        margin-right: 3px;
      }
    }
  }
}
.frame-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  .addframe {
    width: 175px;
    margin-bottom: 30px;
    margin-right: 30px;
    cursor: pointer;
  }
  .addbox {
    width: 250px;
    height: 130px;
    border-radius: 0 20px 0 20px;

    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 3px dashed #67b0dc;
    cursor: pointer;
    .add {
      font-size: 40px;
    }
    .addtip {
      font-size: 20px;
      color: #67b0dc;
      margin-bottom: 16px;
    }
  }
  .cell {
    width: 175px;
    height: 120px;
    background-size: 100% 100%;
    display: flex;
    flex-direction: row;
    padding: 25px 15px 15px 15px;
    margin-bottom: 30px;
    box-sizing: border-box;
    margin-right: 30px;
    .tx {
      width: 92px;
      height: 92px;
      margin-right: 20px;
    }
    &.select {
      border: 3px solid #67b0dc;
    }
    .msg {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .top {
        cursor: pointer;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #fff;
        font-size: 18px;
        img {
          width: 20px;
          margin-left: 10px;
        }
      }
      .foot {
        font-size: 14px;
        color: #fff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        .order {
          font-size: 30px;
          line-height: 1;
        }
      }
    }
  }
}
.frame-list div,
.frame-list span {
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  -ms-user-select: none;
}
::-webkit-scrollbar-track-piece {
  background-color: #f1f1f1;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #a8b3bb;
  background-clip: padding-box;
  min-height: 28px;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}
</style>
